

class Map{
    defaultOptions() {
        return {
            '$container': null,
            'zoom': 6,
            'center':{
                'lat': 46.52863469527167, 
                'lng': 2.43896484375 
            }
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.$container = this.settings.$container;
        this.data = [];
        this.response = null;

        this.mapInitialized = false;

        this.initialize();
    }

    initialize(){
        var self = this;

        this.$container.html('');

        this.mapId = 'map'+window.uniqid();
        this.$map = $('<div/>')
        .attr('id',this.mapId)
        .addClass('map');


        this.$container.append(this.$map);

        this.initMap();
    }


    getHeight(){
        let height = this.$container.innerHeight();
        if(height <= 0){
            height = '800px';
        }
        return height;
    }

    initMap(){
        this.map = L.map(
            this.$map.get(0),
            {
                'center': [
                    this.settings.center.lat,
                    this.settings.center.lng
                ],
                'zoom': this.settings.zoom,
            }
        );

        L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}', {
            'attribution': 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ',
            'maxZoom': 16
        })
        .addTo(this.map);

        this.mapInitialized = true;
        if(this.response){
            this.setData(this.response);
        }
    }

    setData(xhr){
        var self = this;


        this.response = xhr;
        let data = xhr.data;
        if(this.mapInitialized){
            this.data = data;
            this.$map.css("width","100%");
            this.$map.css("height",this.$container.innerHeight());

            setTimeout(function(){ self.map.invalidateSize()}, 100);

            this.build();
        }else{
            this.showMapUnavailable();
        }
    }

    clearMarkers(){
        /*
        if(this.markerCluster){
            this.markerCluster.clearMarkers();
        }
        if(this.markers){
            for(var i in this.markers){
                var marker = this.markers[i];

                marker.setMap(null);
            }
        }
        */

        this.markers = [];
        /*

        this.map.setZoom(this.settings.zoom);
        this.map.setCenter(new google.maps.LatLng(this.settings.center.lat,this.settings.center.lng));
        */
    }

    showMapUnavailable(){
        this.$map.append(
            $('<div/>')
            .addClass('alert alert-warning p-4 text-center')
            .append(
                "Vue carte non disponible : veuillez accepter l'utilisation des cookies Google Maps ou utiliser la vue liste."
            )
        )
    }

    build(){
        this.clearMarkers();

        for(var i in this.data){
            let item = this.data[i];

            if(item.coordinates == null){
                console.warn("La formation "+item.title+" n'a pas de coordonn&eacute;es.");
            }else{

                let marker = this.buildMarker(item);
                this.markers.push(marker);
            }
        }

        this.buildMarkerCluster();

    }

    buildMarkerCluster(){

        if(!this.markerCluster){
            let options = {
            };
            this.markerCluster = L.markerClusterGroup(options);
            this.map.addLayer(this.markerCluster);
        }else{
            this.markerCluster.clearLayers();
        }

        for(var i in this.markers){
            let marker = this.markers[i];

            this.markerCluster.addLayer(marker);
        }

    }

    buildMarker(item){
        var self = this;

        let position = item.coordinates;

        position.lng += (Math.random() / 25000);
        position.lat += (Math.random() / 25000);
        /*
        if(!this.infowindow){
            this.infowindow = new google.maps.InfoWindow();
        }

        let marker = new google.maps.Marker({
            'position': position,
            'map': this.map,
            'description': this.buildMarkerContent(item),
        });

        google.maps.event.addListener(marker, 'click', function() {
            self.infowindow.setOptions({
                'content': this.description
            });
            self.infowindow.open(self.map, marker);
        });
        */


        /*icon font-icon?
        let icon = L.divIcon({
            'html': '<i class="icon icon-marker"></i>',
            'iconSize': [48, 48],
            'className': 'leaflet-icon',
        })
        */

        let icon = L.icon({
            'iconUrl': '/public/assets/img/leaflet/marker-icon.png',
            'shadowUrl': '/public/assets/img/leaflet/marker-shadow.png',

        })
        let options = {
            'icon': icon,
        };
        let marker = L.marker([position.lat,position.lng],options);

        let $content = this.buildMarkerContent(item);
        marker.bindPopup($content);
        

        return marker;
    }

    buildMarkerContent(item){
        let $html = $('<div/>');


        let period = item.periode;

        let url = '/formation/detail?id='+item.Id;

        let $btnShow = $('<a/>')
        .attr('href',url)
        .addClass('btn btn-icon btn-text text-primary formation-btn')
        .append(
            "Voir plus de d&eacute;tails"
        )
        .append(
            $('<i/>')
            .addClass('icon icon-maximise')
        )

        let subject = "["+item.title+"] "+item.diplome.TitreCourtDiplome;
        let urlContact = 'mailto:'+item.organisme.email+'?subject='+subject;
        let $btnContact = $('<a/>')
        .attr('href',urlContact)
        .addClass('btn btn-primary formation-contact-btn')
        .append("Contactez l'organisme");

        $html.append(
            $('<div/>')
            .addClass('formation-infowindow text-primary')
            .append(
                $('<div/>')
                .addClass('formation')
                .append(
                    $('<div/>')
                    .addClass('formation-diplome')
                    .append(
                        $('<label/>')
                        .addClass('label formation-diplome-label')
                        .append(
                            $('<i/>')
                            .addClass('icon icon-xs icon-diplome')
                        )
                        .append(" Diplome")
                    )
                    .append(
                        $('<div/>')
                        .addClass('formation-club-value')
                        .attr('title',item.diplome.TitreDiplome)
                        .append(item.diplome.TitreCourtDiplome)
                    )
                )
                .append(
                    $('<hr/>')
                )
                .append(
                    $('<div/>')
                    .addClass('formation-club')
                    .append(
                        $('<label/>')
                        .addClass('label formation-club-label')
                        .append(
                            $('<i/>')
                            .addClass('icon icon-xs icon-club')
                        )
                        .append(" Club")
                    )
                    .append(
                        $('<div/>')
                        .addClass('formation-club-value')
                        .append(item.organisme.label)
                    )
                )
                .append(
                    $('<hr/>')
                )
                .append(
                    $('<div/>')
                    .addClass('formation-lieu')
                    .append(
                        $('<label/>')
                        .addClass('label formation-lieu-label')
                        .append(
                            $('<i/>')
                            .addClass('icon icon-xs icon-marker')
                        )
                        .append(" Lieu")
                    )
                    .append(
                        $('<div/>')
                        .addClass('formation-lieu-value')
                        .append(item.LieuFormation)
                    )
                )
                .append(
                    $('<hr/>')
                )
                .append(
                    $('<div/>')
                    .addClass('formation-period')
                    .append(
                        $('<label/>')
                        .addClass('label formation-period-label')
                        .append(
                            $('<i/>')
                            .addClass('icon icon-xs icon-calendar')
                        )
                        .append(" Date(s)")
                    )
                    .append(
                        $('<div/>')
                        .addClass('formation-period-value')
                        .append(period)
                    )
                )
                .append(
                    $('<hr/>')
                )
                .append(
                    $('<div/>')
                    .addClass('d-flex justify-content-end')
                    //.append($btnContact)
                    .append($btnShow)
                )
            )
        )


        return $html.html();
    }


    onShow(){
        this.map.invalidateSize();
    }


}

module.exports = Map;